package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.GameTableRepository
import fr.manyverse.app.domain.validation.GameTableValidator

class UpdateGameTableNameUseCase(
    private val repository: GameTableRepository
) {
    suspend operator fun invoke(tableId: String, name: String): Result<Unit> {
        GameTableValidator.validateName(name).onFailure { return Result.failure(it) }
        return repository.updateTableName(tableId, name.trim())
    }
}
